import React from 'react'

import clsx from 'clsx'
import { useRouter } from 'next/router'

import Button from 'components/Button'
import { useEventContext } from 'context/EventContext'
import detachTask from 'helpers/detachTask'
import { getSelectedFilters } from 'helpers/filters'

import classes from './Header.module.scss'

/** @type {import("./types").default} */
const Header = ({ facets, rootUrl, title, clearCallback, disableSPA, softSPA, softUpdate }) => {
  const router = useRouter()
  const { addEvent } = useEventContext()
  const selectedFilters = getSelectedFilters(facets)

  const filterFacetTitle =
    selectedFilters === 0 ? title : `${selectedFilters} ${selectedFilters === 1 ? 'filter' : 'filters'} applied`

  const handleOnClick = () => {
    clearCallback()
    detachTask(() => {
      if (softSPA) {
        softUpdate(rootUrl)
      } else if (disableSPA) {
        window.location.href = rootUrl
      } else {
        router.push(rootUrl, undefined, { scroll: false })
      }
    })
  }

  return (
    <div className={clsx('Header', classes.root)}>
      <span className={classes.title}>{filterFacetTitle}</span>
      {selectedFilters > 0 && (
        <Button
          className={classes.button}
          onClick={handleOnClick}
          variant="outlined"
          {...addEvent({
            engagementDestination: 'filter_clear',
            engagementComponent: 'filter',
            engagementDetails: 'button_clear',
            name: 'engagement_filter',
          })}
        >
          Clear
        </Button>
      )}
    </div>
  )
}

export default Header
